import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';
import type { MouseEvent } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Selection<Selected> = {
  value?: Selected;
  onChange?: (event: MouseEvent<HTMLElement>, value: Selected) => void;
};

type Exclusivity<Value> = ({ exclusive: true } & Selection<Value | null>) | ({ exclusive?: false } & Selection<Value[]>);

type Props<Value> = WithoutStyleOverrides<Omit<MuiToggleButtonGroupProps, 'exclusive' | 'value' | 'onChange'>>
  & Exclusivity<Value>;

export function ToggleButtonGroup<Value>(props: Props<Value>) {
  return <MuiToggleButtonGroup {...props} />;
}

export type { Props as ToggleButtonGroupProps };
